module.exports = __webpack_public_path__ + "static/media/about-03.474f1155.png";